import React, { useEffect } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useAuth } from '../auth/AuthProvider';
import { colors } from '../theme/designTheme';

const Logout = () => {
  const { logout } = useAuth();

  useEffect(() => {
    logout();
  }, [logout]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        bgcolor: colors.bg,
        gap: 2,
      }}
    >
      <CircularProgress sx={{ color: colors.accent }} />
      <Typography
        sx={{
          fontFamily: 'Lexend',
          fontSize: '13px',
          color: colors.textSecondary,
        }}
      >
        Signing out...
      </Typography>
    </Box>
  );
};

export default Logout;
